export default class MaturityRatingService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getSimpleList(params) {
		return this.apiService.callGet('me/maturityRatings/simple', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/MaturityRatingService.js